import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const directionBody = `Welcome to Desert Sage Seminars!

FOR RETURNING STUDENTS: Please update your license expiration date in your Modify Profile folder on your Dashboard to clear the system for your NEW cycle

Where to Find Your Classes To Begin

*SELECT YOUR OWN package of (3 or 6) classes

Click on Available Classes folder
Click button in box to choose your class
Click on the Enroll Me button
Click on My Courses folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*PRESET Package of (6 or 8) classes:
Click on My Classes folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*SINGLE Class
Click on your My Classes folder
Click on class Title to enter class
Click on YOUR CLASS button to begin`;
export function EditDirectionText() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-671">
      <div className="flex items-center justify-between" data-id="element-672">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-673">
          Edit Direction Text
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-674">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-675">
        <CardContent className="pt-6" data-id="element-676">
          <form className="space-y-5" data-id="element-677">
            <Input label="Title" defaultValue="Direction" data-id="element-678" />

            <div data-id="element-679">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-680">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-681">
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-682">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-683">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-684" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-685">
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-686" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-687">
                      {ic}
                    </button>)}
                </div>
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-688">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-689">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-690" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-691">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-692" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-693">
                    <option data-id="element-694">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-695">
                    <option data-id="element-696">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-697">
                    <option data-id="element-698">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-699">
                    <option data-id="element-700">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-701" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-702">
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[300px] bg-white" defaultValue={directionBody} data-id="element-703" />
              </div>
            </div>

            <div className="pt-2" data-id="element-704">
              <Button type="submit" data-id="element-705">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}